import { HttpService } from "../core/http";
import { Injectable } from '@angular/core';
import { IContract, IStore } from '../_entities';
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";

@Injectable()
export class ContractService extends DataAccessServiceBase<IContract> {
  
    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return "api/contract";
    }

    getContracts(storeId: number): Promise<IContract[] | any> {
		return this.httpService.get<IContract[]>(`api/store/${storeId}/contract`)
            .catch(e => {
                this.validationService.handleError(e);
            });
	}

	getContract(id: number): Promise<IContract> {
		return this.httpService.get<IContract>(`api/contract/${id}`);
	}

	getCentralContracts(typeId?: number): Promise<IContract[]> {
		if (!!typeId) {
			return this.httpService.get<IContract[]>(`api/central-contract/type/${typeId}`);
		} else {
			return this.httpService.get<IContract[]>(`api/central-contract`);
		}
	}

	getCentralContractEffectiveCoverage(id: number): Promise<IStore[]> {
		return this.httpService.get<IStore[]>(`api/central-contract/${id}/effective-coverage`);
	}


	getContractNotifications() {
		return this.httpService.get<IContract[]>(`api/contract/notificationreport`);
	}


	addBreakClause(contractId: number): Promise<any> {
		return this.httpService.post<any>(`api/contract/${contractId}/contractbreakclause`, {});
	}

	patchBreakClause = (id: number, prop: string, value: any) => this.httpService.patch<any>(`/api/contractbreakclause/${id}`, [{ "op": "replace", "path": `/${prop}`, "value": value }]);

	deleteBreakClause = (id: number) => this.httpService.delete<any>(`/api/contractbreakclause/${id}`);

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/contract.service.ts